import React from 'react';

function Settings(props) {
    return (
        <div>
            <h1>Settings</h1>
        </div>
    );
}

export default Settings;